import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ModalState } from '../store/modalState';
import { ById } from '../store/normalizedState';

import * as ReducerHelper from './reducerHelper';

export function modalsReducer(state: ById<ModalState> = {}, action: AllActions): ById<ModalState> {
  switch (action.type) {
    case InternalActionTypes.OpenModal:
      return ReducerHelper.updateItemByFunc(
        state,
        i => ({ ...i, open: true, props: action.modalProps }),
        action.modalId,
      );
    case InternalActionTypes.CloseModal:
      return ReducerHelper.removeItem(state, action.modalId);
    default:
      return state;
  }
}
